import {type PutTenantV2ApiReq} from '@dms/api/base';

import {type FormValues} from '../types';

const EMPTY_SELF_EMPLOYED_INFORMATION: NonNullable<
  PutTenantV2ApiReq['contactInformation']['selfEmployedInformation']
> = {
  titleBefore: null,
  firstName: '',
  lastName: '',
  titleAfter: null,
  phoneNumber: null,
  emailAddress: null,
};

export const normalizeSelfEmployedInformation = (
  selfEmployedInformation: FormValues['contactInformation']['selfEmployedInformation']
): NonNullable<PutTenantV2ApiReq['contactInformation']['selfEmployedInformation']> => ({
  ...EMPTY_SELF_EMPLOYED_INFORMATION,
  ...selfEmployedInformation,
});
